import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { postReceta, setReceta, setShowForm } from "../../../actions/recetasDigitales/RecetasDigitales";

export const ModalAlertaFecha = (props) => {
  const dispatch = useDispatch();
  const { recetaSeleccionada } = useSelector((state) => state.recetasDigitales);

  const onClickAceptar = (e) => {
    recetaSeleccionada.Clonada = false;
    const data = {
      ...recetaSeleccionada,
      idAfiliado: props.idAfiliado,
      idTipoReceta: props.idTipoReceta,
      fecha: props.fecha
    };

    dispatch(setReceta(data));
    dispatch(postReceta(data, setShowForm, null, recetaSeleccionada === null));
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>La fecha propuesta por defecto al repetir una receta es la de hoy. ¿Desea continuar?</DialogTitle>
      <DialogContent>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              NO
            </Button>
            <Button type="submit" variant="contained" color="primary" onClick={onClickAceptar}>
              SI
            </Button>
          </div>
      </DialogContent>
    </Dialog>
  );
};
